export const INDEX_PERSON_INVESTED_PROJECTS_ATTEMPT = 'INDEX_PERSON_INVESTED_PROJECTS_ATTEMPT';
export type INDEX_PERSON_INVESTED_PROJECTS_ATTEMPT = typeof INDEX_PERSON_INVESTED_PROJECTS_ATTEMPT;

export const INDEX_PERSON_INVESTED_PROJECTS_SUCCESS = 'INDEX_PERSON_INVESTED_PROJECTS_SUCCESS';
export type INDEX_PERSON_INVESTED_PROJECTS_SUCCESS = typeof INDEX_PERSON_INVESTED_PROJECTS_SUCCESS;

export const INDEX_PERSON_INVESTED_PROJECTS_FAILURE = 'INDEX_PERSON_INVESTED_PROJECTS_FAILURE';
export type INDEX_PERSON_INVESTED_PROJECTS_FAILURE = typeof INDEX_PERSON_INVESTED_PROJECTS_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/project/index-person-invested/Types.tsx